import React from 'react';
import classNames from 'classnames';

export function ImportProgressBlock({ blockProps }) {
	const { entityData, onRemove } = blockProps;
	const { name, type, icon, error, started, page, pageCount, progress, done } = entityData;

	return (
		<div className={classNames("import-progress-block", { error })}>
			<div className="import-info">
				<div className="file">
					<i className={`icon-${type}-file`}></i>
					<span className="file-name">{name}</span>
				</div>
				<div className="progress-text">
				{error ?
					<ImportError error={error} /> :
				(page || pageCount) ?
					<PageText page={page} pageCount={pageCount}></PageText> :
					getProgressText(progress)
				}
				</div>
				<ProgressBar started={started} page={page} pageCount={pageCount} progress={progress} />
			</div>
			<a className="cancel-button" onClick={onRemove} title="取消">取消</a>
		</div>
	);
}

function PageText({ page, pageCount }) {
	return (
		<span>
			正在导入{page && `第 ${page} 页`}{pageCount && `，共 ${pageCount} 页`}...
		</span>
	);
}

function getProgressText(progress) {
	if (!progress) return '正在导入...';
	progress = Math.floor(progress * 100);
	return `正在导入 (${progress}%)...`;
}

function ProgressBar({ started, page, pageCount, progress }) {
	if (!progress) {
		progress = 0.001;
		if (started) {
			progress += 0.049;
		}
		if (page) {
			progress += 0.05;
		}
		progress += pageCount ? 0.9 * page / pageCount : 0;
	}
	// console.log((progress || 0).toFixed(2), `${page}/${pageCount}`);
	return (
		<div className={classNames("progress-bar")}>
			<div className="progress-indicator" style={{
				transform: progress ? `scale3d(${progress}, 1, 1)` : null
			}}></div>
		</div>
	);
}

function ImportError({ error }) {
	if (!error) {
		return null;
	}
	if (error.type === 'SizeLimitExcceed') {
		const m = s => Math.floor(s / 102.4 / 1024) / 10 + 'M';
		return <span className="error">文件尺寸（{m(error.size)}）超过最大限制（{m(error.maxSize)}）</span>;
	}
	if (error.type === 'ConvertError') {
		return <span className="error">转换失败：{error.detail}</span>;
	}
	return <span className="error">错误：{error.type}</span>;
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/component/ImportProgressBlock.jsx